"use client";

// import { getAOSAnimation } from "@litonarefin/utils/getAOSAnimation";
import { getBorderCSS } from "@litonarefin/utils/getBorderCSS";
import { getDimensionCSS } from "@litonarefin/utils/getDimensionCSS";
import { FSCheckout } from "freemius-checkout-js";
import { useState, useEffect, Fragment, useRef, Suspense } from "react";
import { useRouter } from "next/navigation";

const FreemiusButton = ({ attributes }) => {
  const router = useRouter();

  const {
    pricingTableId,
    productName,
    pluginId,
    billingCycle,
    publicKey,
    planId,
    isCoupon,
    couponCode,
    numberOfLicenses,
    productImageURL,
    btnColor,
    btnBgColor,
    border,
    borderRadius,
    padding,
    width,
  } = attributes;

  if (!pluginId) return null;

  // const allAOS = getAOSAnimation(attributes);

  const btnRef = useRef(null);

  const checkoutConfig = new FSCheckout({
    plugin_id: pluginId,
    public_key: publicKey,
    plan_id: planId,
    image: productImageURL,
  });

  const [fsCheckout] = useState(checkoutConfig);

  /**
   * Open Checkout
   * @param {*} e
   */
  const getCheckout = (e) => {
    e.preventDefault();
    // Check DOM set Attributes PlanId & License
    const domPlanId = btnRef.current.getAttribute("plan_id");
    const domLicenses = btnRef.current.getAttribute("license");

    // Checkout Freemius
    fsCheckout.open({
      billing_cycle: billingCycle,
      plan_id: domPlanId || planId,
      licenses: domLicenses || numberOfLicenses,
      title: productName,
      coupon: couponCode,
      hide_coupon: isCoupon,
      success: (data) => {},
      // Purchase Completed
      purchaseCompleted: function (response) {
        var isTrial = null != response.purchase.trial_ends,
          isSubscription = null != response.purchase.initial_amount,
          total = isTrial
            ? 0
            : (isSubscription
                ? response.purchase.initial_amount
                : response.purchase.gross
              ).toString(),
          productName = "WP Adminify",
          storeUrl = "https://wpadminify.com",
          storeName = "WP Adminify";

        // Facebook Pixel
        if (typeof fbq !== "undefined") {
          fbq("track", "Purchase", {
            currency: response.purchase.currency.toUpperCase(),
            value: total,
          });
        }

        setTimeout(() => {
          router.push("/thank-you");
        }, 3000);
      },
    });
  };

  useEffect(() => {
    // close and destroy the DOM related stuff on unmount
    return () => {
      fsCheckout.close();
      // fsCheckout.destroy();
    };
  }, [fsCheckout]);

  return (
    <Fragment>
      <Suspense>
        <button
          ref={btnRef}
          className="jlt-freemius-btn jlt-shadow-[0px_0px_20px_rgba(173,173,188,0.15)] jlt-rounded-[25px] jlt-py-3 jlt-px-6 jlt-font-bold jlt-text-sm jlt-leading-[18px] jlt-text-center jlt-text-white jlt-border-none jlt-cursor-pointer"
          // {...allAOS}
          onClick={(e) => getCheckout(e)}
          id={pricingTableId}
        >
          {attributes?.btnText || "Button Text"}
        </button>
        <style jsx>{`
          .jlt-freemius-btn {
            ${btnBgColor ? `background: ${btnBgColor};` : ""}
            ${btnColor ? `color: ${btnColor};` : ""}
                    ${borderRadius ? `border-radius: ${borderRadius}px;` : ""}
                    ${width ? `width: ${width};` : ""}
                    ${getBorderCSS(border) ? getBorderCSS(border) : ""}
                    ${getDimensionCSS(padding, "padding")
              ? getDimensionCSS(padding, "padding")
              : ""}
          }
        `}</style>
      </Suspense>
    </Fragment>
  );
};

export default FreemiusButton;
